import { Box, useMediaQuery } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import TextPageComponent from "src/features/TextPageComponent";
import TrainWithContainer from "src/features/TrainWithContainer";
import { theme } from "src/theme/theme";

export const Route = createFileRoute("/create/_layout/qrCode")({
  component: RouteComponent,
});

function RouteComponent() {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));

  let isiOS = false;

  if (navigator.userAgent.includes("iPhone")) {
    isiOS = true;
  }

  const renderDownloadButtons = () => (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
      alignItems="center"
      marginTop={2}
    >
      {isiOS ? (
        <Box
          component="a"
          href="https://apps.apple.com/us/app/trainwell/id1466445684"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: "block",
            "& img": {
              height: "60px",
              width: "auto",
            },
          }}
        >
          <img
            src="/assets/app-store-badge.png"
            alt="Download on the App Store"
          />
        </Box>
      ) : (
        <Box
          component="a"
          href="https://play.google.com/store/apps/details?id=com.mycopilot.copilotapp&hl=en_US"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: "block",
            "& img": {
              height: "60px",
              width: "auto",
            },
          }}
        >
          <img
            src="/assets/google-play-badge.png"
            alt="Get it on Google Play"
          />
        </Box>
      )}
    </Box>
  );

  return (
    <TextPageComponent
      chipText="Exclusive invite-only access to trainwell teams"
      titleText={
        isMobile
          ? "Download the app"
          : "Your team's waiting! Scan to download the app"
      }
      bodyText="Everything you need to succeed is waiting in the app."
      customComponent={
        <Box
          display="flex"
          flexDirection="column"
          marginTop={2}
          alignItems="center"
        >
          {isMobile ? (
            renderDownloadButtons()
          ) : (
            <Box
              component="img"
              src="../assets/teams/freemium-app-download-qr-code.png"
              alt="QR code to download the app"
              width="70%"
              sx={{
                marginTop: theme.spacing(2),
                marginLeft: theme.spacing(2),
                marginRight: theme.spacing(2),
                marginBottom: theme.spacing(2),
              }}
            />
          )}
          <Box sx={{ height: 20 }} />
          <TrainWithContainer
            text="loved by 45,000+ members"
            images={[
              "../assets/stock-image-1.png",
              "../assets/stock-image-2.png",
              "../assets/stock-image-3.png",
            ]}
          />
        </Box>
      }
    />
  );
}
